import {
  IRedactionListItem,
  RedactionState,
} from '@/dataroom/ui/common/DataroomExplorer/Modals/DocumentViewer/DataroomViewer/plugins/RedactionPlugin/types';

export const isApplied = ({ state }: IRedactionListItem) => (
  state === RedactionState.Applied
);
